"use strict";
/**
 * D1 Database Type Definitions
 *
 * These types distinguish between:
 * - D1 Row Types: What actually comes from the database (JSON as strings)
 * - Application Types: What the application uses (parsed objects)
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=types.js.map